var React = require('react');

function IconBlind (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1,.cls-2{fill:none;stroke:#142b6f;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}.cls-2{fill:#142b6f}")),React.createElement("circle",{"cx":"20","cy":"20","r":"14","className":"cls-1","key":1}),React.createElement("path",{"d":"M19.62,23.37V23A3.23,3.23,0,0,1,21.19,20l1.08-.74A3.91,3.91,0,0,0,24,16a3.75,3.75,0,0,0-4-3.85,3.9,3.9,0,0,0-4,3.3l0,.38","className":"cls-1","key":2}),React.createElement("circle",{"cx":"19.65","cy":"27.34","r":".5","className":"cls-2","key":3})]);
}

IconBlind.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 40 40"};

module.exports = IconBlind;

IconBlind.default = IconBlind;
